var app = angular.module("leonardo");

var AdminStates = function ($stateProvider) {
  $stateProvider.state('admin', {
    url: "/admin",
    parent: 'authenticated.layout-main',
    title: 'Account list',
    views: {
      'user': {
        templateUrl: 'views/templates/user/logged.html',
        controller: 'UserMenu'
      }
    },
    redirectTo: 'admin.accounts'
  });

  $stateProvider.state('admin.request', {
    url: "/request",
    title: 'Account Request List',
    request: true,
    views: {
      'content@authenticated.layout-main': {
        templateUrl: 'views/templates/admin/account/list-request.html',
        controller: 'AdminAccountListController'
      },
      'filters@authenticated.layout-main': {
        templateUrl: 'views/templates/filter/filters-base.html',
        controller: 'AdminAccountFiltersController'
      }
    }
  });


  $stateProvider.state('admin.accounts', {
    url: "/accounts",
    title: 'Account List',
    views: {
      'content@authenticated.layout-main': {
        templateUrl: 'views/templates/admin/account/list.html',
        controller: 'AdminAccountListController'
      },
      'actions@authenticated.layout-main': {
        templateUrl: 'views/templates/actions/register-list.html',
        controller: 'UserListActions'
      },
      'filters@authenticated.layout-main': {
        templateUrl: 'views/templates/filter/filters-base.html',
        controller: 'AdminAccountFiltersController'
      }
    },
    ncyBreadcrumb: {
      label: 'Accounts'
    }
  });

  $stateProvider.state('admin.accounts.add', {
    url: "/add",
    cssClass: 'page-home',
    redirect: true,
    views: {
      'content@authenticated.layout-main': {
        templateUrl: 'views/templates/user/register-account.html'
      },
      'actions@authenticated.layout-main': {},
      'filters@authenticated.layout-main': {}
    },
    ncyBreadcrumb: {
      label: 'Add new account'
    }

  });


  $stateProvider.state('admin_account', {
    url: "/admin-account-manage",
    title: 'Management Invitations',
    parent: 'authenticated.layout-main',
    views: {
      'user': {
        templateUrl: 'views/templates/user/logged.html',
        controller: 'UserMenu'
      },
      'content': {
        templateUrl: 'views/templates/admin/account/account-manage.html',
        controller: 'ManageAccountListController'
      }
    }
  });


  $stateProvider.state('client-instances', {
    url: "/client-instances",
    parent: 'authenticated.layout-main',
    title: 'Client Instance List',
    views: {
      'user': {
        templateUrl: 'views/templates/user/logged.html',
        controller: 'UserMenu'
      },
      'content@authenticated.layout-main': {
        templateUrl: 'views/templates/admin/white-label/list.html',
        controller: 'AdminClientInstanceListController'
      },
      'actions@authenticated.layout-main': {
        templateUrl: 'views/templates/actions/white-label-list.html',
        controller: 'UserListActions'
      },
      'filters@authenticated.layout-main': {
        templateUrl: 'views/templates/filter/filters-base.html',
        controller: 'AdminClientInstanceFiltersController'
      }
    },
    ncyBreadcrumb: {
      label: 'Client Instances'
    }
  });

  $stateProvider.state('my-white-label', {
    url: "/my-white-label",
    parent: 'authenticated.layout-main',
    title: 'My Client Instance',
    views: {
      'user': {
        templateUrl: 'views/templates/user/logged.html',
        controller: 'UserMenu'
      },
      'content': {
        templateUrl: 'views/templates/admin/white-label/form.html',
        controller: 'ClientInstanceController'
      },
      'actions@authenticated.layout-main': {},
      'filters@authenticated.layout-main': {}
    },
    resolve: {
      whiteLabelObj: ['AuthDataService', function(AuthDataService) {
        return AuthDataService.authData.whiteLabel && AuthDataService.authData.whiteLabel.id;
      }]
    },
    ncyBreadcrumb: {
      label: 'My Client Instance'
    }
  });

  $stateProvider.state('client-instances.add', {
    url: "/add",
    cssClass: 'page-home',
    redirect: true,
    views: {
      'content@authenticated.layout-main': {
        templateUrl: 'views/templates/admin/white-label/form.html',
        controller: 'ClientInstanceController',
      },
      'actions@authenticated.layout-main': {},
      'filters@authenticated.layout-main': {}
    },
    resolve: {
      whiteLabelObj: ['ClientInstanceService', function(ClientInstanceService) {
        return null;
      }]
    },
    ncyBreadcrumb: {
      label: 'Add new Client Instance'
    }
  });
};

app.config(['$stateProvider', AdminStates]);
